import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TodoModel, TodoCreatePayload } from '../models/app.models';

/**
 * CRUD nad `/api/todos` (viz TodosController). Vzor podle ProposalService —
 * jedna metoda na jeden endpoint, bez lokálního cache/state (to drží
 * AssistantBadgeService pro odznak a TodoListComponent pro seznam).
 */
@Injectable({
  providedIn: 'root'
})
export class TodoService {
  private apiUrl = '/api/todos';

  constructor(private http: HttpClient) {
  }

  /**
   * status/transferId nevyplněné => BE vrací jen aktivní otevřené úkoly.
   * snoozed=true => jen odložené (SnoozedUntil v budoucnu).
   */
  getList(status?: number, transferId?: number, snoozed?: boolean): Observable<TodoModel[]> {
    let params = new HttpParams();
    if (status != null) {
      params = params.set('status', status);
    }
    if (transferId != null) {
      params = params.set('transferId', transferId);
    }
    if (snoozed) {
      params = params.set('snoozed', true);
    }
    return this.http.get<TodoModel[]>(this.apiUrl, { params });
  }

  /** Lehký COUNT pro odznak (viz AssistantBadgeService) — nenačítá celý seznam. */
  getOpenCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/open-count`);
  }

  getSnoozedCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/snoozed-count`);
  }

  create(payload: TodoCreatePayload): Observable<TodoModel> {
    return this.http.post<TodoModel>(this.apiUrl, payload);
  }

  update(id: number, payload: TodoCreatePayload): Observable<TodoModel> {
    return this.http.put<TodoModel>(`${this.apiUrl}/${id}`, payload);
  }

  complete(id: number): Observable<TodoModel> {
    return this.http.post<TodoModel>(`${this.apiUrl}/${id}/complete`, {});
  }

  reopen(id: number): Observable<TodoModel> {
    return this.http.post<TodoModel>(`${this.apiUrl}/${id}/reopen`, {});
  }

  dismiss(id: number): Observable<TodoModel> {
    return this.http.post<TodoModel>(`${this.apiUrl}/${id}/dismiss`, {});
  }

  /** until=null zruší odložení (vrátí mezi aktivní). */
  snooze(id: number, until: string | null): Observable<TodoModel> {
    return this.http.post<TodoModel>(`${this.apiUrl}/${id}/snooze`, { until });
  }
}
